import { render, staticRenderFns } from "./IntegrationDeck.vue?vue&type=template&id=755e23be&lang=pug&"
import script from "./IntegrationDeck.vue?vue&type=script&lang=js&"
export * from "./IntegrationDeck.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDeck.vue?vue&type=style&index=0&id=755e23be&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports